// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_HOME = "/homePage";
const ROOTS_ADMIN = "/admin";
const ROOTS_AUTH = "/auth";
const ROOTS_BASE = "/basePanle";
const ROOTS_DOCTOR = "/doctor";
const ROOTS_SECRETARY = "/secretary";
const ROOTS_PATIENT = "/patient";
const ROOTS_SUPPORTER = "/supporter";
const ROOTS_RADIOGRAPHY = "/radiography";
const ROOTS_LABORATORY = "/laboratory";
const ROOTS_DRUGSTORE = "/drugstore";
const ROOTS_LENDER = "/lender";
const ROOTS_LENDER_SYSTEM = "/lenderSystem";
const ROOTS_RADIOGRAPHY_SYSTEM = "/radiographySystem";
const ROOTS_LABORATORY_SYSTEM = "/laboratorySystem";
const ROOTS_DRUGSTORE_SYSTEM = "/drugstoreSystem";
const ROOTS_QUIZMASTER = "/quizMaster";
const ROOTS_ORGANIZATION = "/organization";
const ROOTS_ORGANIZATIONSYSTEM = "/organizationSystem";

const ROOTS_HEALTHCENTER = "/healthCenter";

// -------------------------------Home   Path---------------------------------------

export const PATH_HOME = {
  root: ROOTS_HOME,

  // مسیرهای پنل اصلی
  home:ROOTS_HOME,
  login: path(ROOTS_HOME, "/login"),
  //test: path(ROOTS_HOME, "/test"),
  CallBack: path(ROOTS_HOME, "/CallBack"),
  UserQuizzes: path(ROOTS_HOME, "/quizzes"),
  UserLoans: path(ROOTS_HOME, "/loans"),
  UserHealthMonitoringAlgorithms: path(
    ROOTS_HOME,
    "/healthMonitoringAlgorithms"
  ),
  // مسیرهای نوبت‌دهی

  HomeAppointmentReservation: path(ROOTS_HOME, "/search/doctor/:drName/:id"),
  CentersAppointmentReservation: path(
    ROOTS_HOME,
    "/search/medicalCenters/:persianTitle/:type/:id"
  ),
  CompletingAppointment: path(
    ROOTS_HOME,
    "/reserve/:drName/:policlinicName/:id"
  ),
  appointmentRules: path(ROOTS_HOME, "/appointmentRules"),

  // مسیرهای مربوط به نوبت‌دهی بر اساس تخصص یا بیماری
  patientAppointmentByExpertise: path(
    ROOTS_HOME,
    "patientAppointment/:expertiseId"
  ),
  patientAppointmentByExpertiseAndCity: path(
    ROOTS_HOME,
    "patientAppointment/:expertiseId/:cityId"
  ),
  patientAppointmentByDrService: path(
    ROOTS_HOME,
    "patientAppointment/:drService"
  ),
  patientAppointmentByDrServiceAndCity: path(
    ROOTS_HOME,
    "patientAppointment/:drService/:cityId"
  ),
  patientAppointmentByDoctorDisease: path(
    ROOTS_HOME,
    "patientAppointment/:doctorDiseaseId"
  ),
  patientAppointmentByDoctorDiseaseAndCity: path(
    ROOTS_HOME,
    "patientAppointment/:doctorDiseaseId/:cityId"
  ),
};

// ------------------------------Auth  Path----------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  register: path(ROOTS_AUTH, "/register"),
  login: path(ROOTS_AUTH, "/login"),
};

// -----------------------------QuizMaster  Path----------------------------------------
export const BREADCRUMB_TITLES_QUIZMASTER = {
  root: { path: ROOTS_QUIZMASTER, title: "آزمونگر" },
  q_DashboardContent: {
    path: path(ROOTS_QUIZMASTER, "/dashboard/quizMasterDashboard"),
    title: "داشبورد",

    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  Quizzes: {
    path: path(ROOTS_QUIZMASTER, "/dashboard/quizzes"),
    title: "ایجاد آزمون",
    parent: path(ROOTS_QUIZMASTER, "/dashboard/quizMasterDashboard"),
  },
  QuizMasterQuizCorrection: {
    path: path(ROOTS_QUIZMASTER, "/dashboard/quizMasterQuizCorrection"),
    title: "تصحیح آزمون",
    parent: path(ROOTS_QUIZMASTER, "/dashboard/quizMasterDashboard"),
  },
};
export const PATH_QUIZMASTER = {
  root: ROOTS_QUIZMASTER,
  Dashboard: path(ROOTS_QUIZMASTER, "/dashboard"),
  q_DashboardContent: path(ROOTS_QUIZMASTER, "/dashboard/quizMasterDashboard"),
  Quizzes: path(ROOTS_QUIZMASTER, "/dashboard/quizzes"),
  QuizMasterQuizCorrection: path(
    ROOTS_QUIZMASTER,
    "/dashboard/quizMasterQuizCorrection"
  ),
  q_Confirmation: path(ROOTS_QUIZMASTER, "/confirmation"),
};

// ------------------------------Admin  Path----------------------------------------

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  dashboard: path(ROOTS_ADMIN, "/dashboard"),
  ListProvince: path(ROOTS_ADMIN, "/dashboard/listProvince"),
  ListBaseUserAddress: path(ROOTS_ADMIN, "/dashboard/listBaseUserAddress"),
  ListCities: path(ROOTS_ADMIN, "/dashboard/listCities"),
  ListJobGroups: path(ROOTS_ADMIN, "/dashboard/listJobGroup"),
  ListJob: path(ROOTS_ADMIN, "/dashboard/listJob"),
  ListInsurances: path(ROOTS_ADMIN, "/dashboard/listInsurances"),
  ListDegree: path(ROOTS_ADMIN, "/dashboard/listDegree"),
  ListGender: path(ROOTS_ADMIN, "/dashboard/listGender"),
  ListOrganizationTypes: path(ROOTS_ADMIN, "/dashboard/listOrganizationTypes"),
  ListBaseUser: path(ROOTS_ADMIN, "/dashboard/listBaseUser"),
  ListMainBodyParts: path(ROOTS_ADMIN, "/dashboard/listMainBodyParts"),
  ListBodyParts: path(ROOTS_ADMIN, "/dashboard/listBodyParts"),
  ListReceptionTypes: path(ROOTS_ADMIN, "/dashboard/listReceptionTypes"),
  ListPaymentTypes: path(ROOTS_ADMIN, "/dashboard/listPaymentTypes"),
  ListDrugType: path(ROOTS_ADMIN, "/dashboard/listDrugType"),
  ListDrugTimes: path(ROOTS_ADMIN, "/dashboard/listDrugTimes"),
  ListDrugCategories: path(ROOTS_ADMIN, "/dashboard/listDrugCategories"),
  ListDrugDosages: path(ROOTS_ADMIN, "/dashboard/listDrugDosages"),
  ListTestCategories: path(ROOTS_ADMIN, "/dashboard/listTestCategories"),
  ListTests: path(ROOTS_ADMIN, "/dashboard/listTests"),
  ListAdmin: path(ROOTS_ADMIN, "/dashboard/listAdmin"),
  ListSecretaries: path(ROOTS_ADMIN, "/dashboard/listSecretaries"),
  ListDiseaseCategories: path(ROOTS_ADMIN, "/dashboard/listDiseaseCategories"),
  ListDisease: path(ROOTS_ADMIN, "/dashboard/listDisease"),
  ListSymptoms: path(ROOTS_ADMIN, "/dashboard/listSymptoms"),
  ListHealthCenters: path(ROOTS_ADMIN, "/dashboard/listHealthCenters"),
  HealthCenterService: path(ROOTS_ADMIN, "/dashboard/healthCenterService"),
  ListHealthCenterService: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthCenterService"
  ),
  ListHealthCenterServices: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthCenterServices"
  ),
  ListHealthCenterServiceCategory: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthCenterServiceCategory"
  ),
  ListHealthCenterServiceInsurances: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthCenterServiceInsurances"
  ),
  ListHealthCenterPart: path(ROOTS_ADMIN, "/dashboard/listHealthCenterPart"),
  ListHealthCenterRoomType: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthCenterRoomType"
  ),
  ListHealthCenterRoom: path(ROOTS_ADMIN, "/dashboard/listHealthCenterRoom"),
  ListHealthCenterBed: path(ROOTS_ADMIN, "/dashboard/listHealthCenterBed"),
  ListRoles: path(ROOTS_ADMIN, "/dashboard/listRoles"),
  ListUserRole: path(ROOTS_ADMIN, "/dashboard/listUserRole"),
  ListPatients: path(ROOTS_ADMIN, "/dashboard/listPatients"),
  ListQuizMaster: path(ROOTS_ADMIN, "/dashboard/listQuizMaster"),
  ListDoctors: path(ROOTS_ADMIN, "/dashboard/listDoctors"),
  ListLaboratories: path(ROOTS_ADMIN, "/dashboard/listLaboratories"),
  ListMatab: path(ROOTS_ADMIN, "/dashboard/ListMatab"),
  ListMedicalSystems: path(ROOTS_ADMIN, "/dashboard/listMedicalSystems"),
  ListRadiography: path(ROOTS_ADMIN, "/dashboard/listRadiography"),
  ListDrugstores: path(ROOTS_ADMIN, "/dashboard/listDrugstores"),
  ListFellowships: path(ROOTS_ADMIN, "/dashboard/listFellowships"),
  ListExpertise: path(ROOTS_ADMIN, "/dashboard/listExpertise"),
  ListRadiologyCategories: path(
    ROOTS_ADMIN,
    "/dashboard/listRadiologyCategories"
  ),
  ListPatientSmokeHistories: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientSmokeHistories"
  ),
  ListPatientWeightHistories: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientWeightHistories"
  ),
  ListTestAnswerByPatients: path(
    ROOTS_ADMIN,
    "/dashboard/listTestAnswerByPatients"
  ),
  ListRadiologyAnswerByPatients: path(
    ROOTS_ADMIN,
    "/dashboard/listRadiologyAnswerByPatients"
  ),
  ListPeriods: path(ROOTS_ADMIN, "/dashboard/listPeriods"),
  ListSupporters: path(ROOTS_ADMIN, "/dashboard/listSupporters"),
  ListSupportContracts: path(ROOTS_ADMIN, "/dashboard/listSupportContracts"),
  ListDoctorDiseaseRadiology: path(
    ROOTS_ADMIN,
    "/dashboard/listDoctorDiseaseRadiology"
  ),
  ListDoctorDiseaseTest: path(ROOTS_ADMIN, "/dashboard/listDoctorDiseaseTest"),
  ListDoctorExpertise: path(ROOTS_ADMIN, "/dashboard/listDoctorExpertise"),
  ListDoctorFellowships: path(ROOTS_ADMIN, "/dashboard/listDoctorFellowships"),
  ListDoctorsServicesCategories: path(
    ROOTS_ADMIN,
    "/dashboard/listDoctorsServicesCategories"
  ),
  ListDoctorsServices: path(ROOTS_ADMIN, "/dashboard/listDoctorsServices"),
  ListDoctorServices: path(ROOTS_ADMIN, "/dashboard/listDoctorServices"),
  ListDoctorServiceInsurances: path(
    ROOTS_ADMIN,
    "/dashboard/listDoctorServiceInsurances"
  ),
  ListDiseaseDoctors: path(ROOTS_ADMIN, "/dashboard/listDiseaseDoctors"),
  ListDiagnosis: path(ROOTS_ADMIN, "/dashboard/listDiagnosis"),
  ListDoctorIntroducePatients: path(
    ROOTS_ADMIN,
    "/dashboard/listDoctorIntroducePatients"
  ),

  listPatientOperates: path(ROOTS_ADMIN, "/dashboard/listPatientOperates"),
  ListDiseaseTests: path(ROOTS_ADMIN, "/dashboard/listDiseaseTests"),
  ListDiseaseRadiology: path(ROOTS_ADMIN, "/dashboard/listDiseaseRadiology"),
  ListRadiology: path(ROOTS_ADMIN, "/dashboard/listRadiology"),
  ListDrug: path(ROOTS_ADMIN, "/dashboard/listDrug"),
  ListDrugInstructions: path(ROOTS_ADMIN, "/dashboard/listDrugInstructions"),
  ListDoctorDiseaseDrugs: path(
    ROOTS_ADMIN,
    "/dashboard/listDoctorDiseaseDrugs"
  ),
  ListDiseaseSymptoms: path(ROOTS_ADMIN, "/dashboard/listDiseaseSymptoms"),
  ListPatientDrugs: path(ROOTS_ADMIN, "/dashboard/listPatientDrugs"),
  ListDrugstoreDrugs: path(ROOTS_ADMIN, "/dashboard/listDrugstoreDrugs"),
  ListRolePermission: path(ROOTS_ADMIN, "/dashboard/listRolePermission"),
  ListPermissionCategoryPermissions: path(
    ROOTS_ADMIN,
    "/dashboard/listPermissionCategoryPermissions"
  ),
  ListSupportRequestSettlements: path(
    ROOTS_ADMIN,
    "/dashboard/listSupportRequestSettlements"
  ),
  ListReceptions: path(ROOTS_ADMIN, "/dashboard/listReceptions"),
  ListDiseaseDrugs: path(ROOTS_ADMIN, "/dashboard/listDiseaseDrugs"),
  ListDrugSimilar: path(ROOTS_ADMIN, "/dashboard/listDrugSimilar"),
  ListDrugInteraction: path(ROOTS_ADMIN, "/dashboard/listDrugInteraction"),
  ListTestDetails: path(ROOTS_ADMIN, "/dashboard/listTestDetails"),
  VisitFormPage: path(ROOTS_ADMIN, "/dashboard/visitFormPage"),
  DoctorVisitFormPage: path(ROOTS_ADMIN, "/dashboard/doctorVisitFormPage"),
  ListAppointmentPatient: path(
    ROOTS_ADMIN,
    "/dashboard/listAppointmentPatient"
  ),
  ListAppointments: path(ROOTS_ADMIN, "/dashboard/listAppointments"),
  ListAppointmentOnlineType: path(
    ROOTS_ADMIN,
    "/dashboard/listAppointmentOnlineType"
  ),
  ListAppointmentDetails: path(
    ROOTS_ADMIN,
    "/dashboard/listAppointmentDetails"
  ),
  ListBloodGroups: path(ROOTS_ADMIN, "/dashboard/listBloodGroups"),
  ListExternalAppointmens: path(
    ROOTS_ADMIN,
    "/dashboard/listExternalAppointmens"
  ),
  ListFamily: path(ROOTS_ADMIN, "/dashboard/listFamily"),
  ListRiskFactors: path(ROOTS_ADMIN, "/dashboard/listRiskFactors"),
  ListDiseaseRiskFactors: path(
    ROOTS_ADMIN,
    "/dashboard/listDiseaseRiskFactors"
  ),
  ListDiseaseExpertise: path(ROOTS_ADMIN, "/dashboard/listDiseaseExpertise"),
  ListLoanTypes: path(ROOTS_ADMIN, "/dashboard/listLoanTypes"),
  ListLoanDocuments: path(ROOTS_ADMIN, "/dashboard/listLoanDocuments"),
  ListLoans: path(ROOTS_ADMIN, "/dashboard/listLoans"),
  ListLender: path(ROOTS_ADMIN, "/dashboard/listLender"),
  ListMedicalLaboratoryTitle: path(
    ROOTS_ADMIN,
    "/dashboard/listMedicalLaboratoryTitle"
  ),
  ListMedicalRadiographyTitle: path(
    ROOTS_ADMIN,
    "/dashboard/listMedicalRadiographyTitle"
  ),
  ListReferrals: path(ROOTS_ADMIN, "/dashboard/listReferrals"),
  ListReferralCategories: path(
    ROOTS_ADMIN,
    "/dashboard/listReferralCategories"
  ),
  ListFinancialCenter: path(ROOTS_ADMIN, "/dashboard/listFinancialCenter"),
  ListBank: path(ROOTS_ADMIN, "/dashboard/listBank"),
   ListCreditPoints: path(ROOTS_ADMIN, "/dashboard/listCreditPoints"),
  ListBankAccounts: path(ROOTS_ADMIN, "/dashboard/listBankAccounts"),
  ListComment: path(ROOTS_ADMIN, "/dashboard/listComment"),
  ListQuizPanel: path(ROOTS_ADMIN, "/dashboard/listQuizPanel"),
  ListQuizMasterQuizPanel: path(
    ROOTS_ADMIN,
    "/dashboard/listQuizMasterQuizPanel"
  ),
  ListQuizCategoryDetails: path(
    ROOTS_ADMIN,
    "/dashboard/listQuizCategoryDetails"
  ),
  ListQuizCategory: path(ROOTS_ADMIN, "/dashboard/listQuizCategory"),
  ListQuestionType: path(ROOTS_ADMIN, "/dashboard/listQuestionType"),
  ListQuizType: path(ROOTS_ADMIN, "/dashboard/listQuizType"),
  ListCourseCategories: path(ROOTS_ADMIN, "/dashboard/listCourseCategories"),
  ListCourse: path(ROOTS_ADMIN, "/dashboard/listCourse"),
  ListLevelScore: path(ROOTS_ADMIN, "/dashboard/listLevelScore"),
  ListQuiz: path(ROOTS_ADMIN, "/dashboard/listQuiz"),
  ListQuizCourse: path(ROOTS_ADMIN, "/dashboard/listQuizCourse"),
  ListQuizCourseScore: path(ROOTS_ADMIN, "/dashboard/listQuizCourseScore"),
  ListQuizScore: path(ROOTS_ADMIN, "/dashboard/listQuizScore"),
  ListQuestion: path(ROOTS_ADMIN, "/dashboard/listQuestion"),
  ListQuizQuestion: path(ROOTS_ADMIN, "/dashboard/listQuizQuestion"),
  AdminQuizCorrection: path(ROOTS_ADMIN, "/dashboard/adminQuizCorrection"),
  ListPatientRadiology: path(ROOTS_ADMIN, "/dashboard/listPatientRadiology"),
  ListPatientTest: path(ROOTS_ADMIN, "/dashboard/listPatientTest"),
  ListInnocence: path(ROOTS_ADMIN, "/dashboard/listInnocence"),
  ListOrganizationCategory: path(
    ROOTS_ADMIN,
    "/dashboard/listOrganizationCategory"
  ),
  ListOrganization: path(ROOTS_ADMIN, "/dashboard/listOrganization"),
  ListOrganizationDoctor: path(
    ROOTS_ADMIN,
    "/dashboard/listOrganizationDoctor"
  ),
  ListOrganizationRoom: path(ROOTS_ADMIN, "/dashboard/listOrganizationRoom"),
  ListOrganizationSystem: path(
    ROOTS_ADMIN,
    "/dashboard/listOrganizationSystem"
  ),
  ListOrganizationPatients: path(
    ROOTS_ADMIN,
    "/dashboard/listOrganizationPatients"
  ),
  ListOrganizationServantContract: path(
    ROOTS_ADMIN,
    "/dashboard/listOrganizationServantContract"
  ),
  ListSocialMedia: path(ROOTS_ADMIN, "/dashboard/listSocialMedia"),
  ListFrequentlyQuestions: path(
    ROOTS_ADMIN,
    "/dashboard/listFrequentlyQuestions"
  ),
  ListFrequentlyQuestionCategories: path(
    ROOTS_ADMIN,
    "/dashboard/listFrequentlyQuestionCategories"
  ),
  ListEquipments: path(ROOTS_ADMIN, "/dashboard/listEquipments"),
  ListEquipmentGroups: path(ROOTS_ADMIN, "/dashboard/listEquipmentGroups"),
  ListServiceEquipments: path(ROOTS_ADMIN, "/dashboard/listServiceEquipments"),
  ListPoliclinicEquipments: path(
    ROOTS_ADMIN,
    "/dashboard/listPoliclinicEquipments"
  ),
  ListPatientEquipmentSalesInvoices: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientEquipmentSalesInvoices"
  ),
  ListNurse: path(ROOTS_ADMIN, "/dashboard/listNurse"),
  ListHealthRecordCategory: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthRecordCategory"
  ),
  ListHealthRecordCategoryDetails: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthRecordCategoryDetails"
  ),
  ListHealthRecord: path(ROOTS_ADMIN, "/dashboard/listHealthRecord"),
  ListSmsPanels: path(ROOTS_ADMIN, "/dashboard/listSmsPanels"),
  ListActivityType: path(ROOTS_ADMIN, "/dashboard/listActivityType"),
  ListEcg: path(ROOTS_ADMIN, "/dashboard/listEcg"),
  ListAltitude: path(ROOTS_ADMIN, "/dashboard/listAltitude"),
  ListTimeOfDay: path(ROOTS_ADMIN, "/dashboard/listTimeOfDay"),
  ListInjectionType: path(ROOTS_ADMIN, "/dashboard/listInjectionType"),
  ListInjectionBodyPart: path(ROOTS_ADMIN, "/dashboard/listInjectionBodyPart"),
  ListManufacturer: path(ROOTS_ADMIN, "/dashboard/listManufacturer"),
  ListPupilSize: path(ROOTS_ADMIN, "/dashboard/listPupilSize"),
  ListSkinObservation: path(ROOTS_ADMIN, "/dashboard/listSkinObservation"),
  ListPatientVaccineHistory: path(ROOTS_ADMIN, "/dashboard/listPatientVaccineHistory"),
  ListVaccine: path(ROOTS_ADMIN, "/dashboard/listVaccine"),
  ListVaccineDoseType: path(ROOTS_ADMIN, "/dashboard/listVaccineDoseType"),
  ListVaccineType: path(ROOTS_ADMIN, "/dashboard/listVaccineType"),
  ListPatientSleepQualityHistory: path(ROOTS_ADMIN, "/dashboard/listPatientSleepQualityHistory"),
  ListTestFormula: path(ROOTS_ADMIN, "/dashboard/listTestFormula"),
  ListVaccineDoseSchedule: path(
    ROOTS_ADMIN,
    "/dashboard/listVaccineDoseSchedule"
  ),
  ListPatientActivityHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientActivityHistory"
  ),
  ListPatientBloodOxygenLevelHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientBloodOxygenLevelHistory"
  ),
  ListPatientBloodPressureHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientBloodPressureHistory"
  ),
  ListPatientBloodSugarHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientBloodSugarHistory"
  ),
  ListPatientBodyTemperatureHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientBodyTemperatureHistory"
  ),
  ListPatientConsciousnessLevelHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientConsciousnessLevelHistory"
  ),
  ListPatientEcgHistory: path(ROOTS_ADMIN, "/dashboard/listPatientEcgHistory"),
  ListPatientFluidBalanceHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientFluidBalanceHistory"
  ),
  ListPatientHealthNote: path(ROOTS_ADMIN, "/dashboard/listPatientHealthNote"),
  ListPatientHeartRateHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientHeartRateHistory"
  ),
  ListPatientOxygenSaturationHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientOxygenSaturationHistory"
  ),
  ListPatientPainScoreHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientPainScoreHistory"
  ),
  ListPatientPupilCheckHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientPupilCheckHistory"
  ),
  ListPatientRespiratoryRateHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientRespiratoryRateHistory"
  ),
  ListPatientSkinObservationHistory: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientSkinObservationHistory"
  ),
  ListMeasurementUnit: path(ROOTS_ADMIN, "/dashboard/listMeasurementUnit"),
  ListUnitConversions: path(ROOTS_ADMIN, "/dashboard/listUnitConversions"),
  ListHealthMonitoringAlgorithms: path(
    ROOTS_ADMIN,
    "/dashboard/listHealthMonitoringAlgorithms"
  ),
  ListPatientHealthMonitorings: path(
    ROOTS_ADMIN,
    "/dashboard/listPatientHealthMonitorings"
  ),
  ListPackages: path(ROOTS_ADMIN, "/dashboard/listPackages"),
  ListTestDeviceCategory: path(
    ROOTS_ADMIN,
    "/dashboard/listTestDeviceCategory"
  ),
  ListSupportInformation: path(
    ROOTS_ADMIN,
    "/dashboard/listSupportInformation"
  ),
  ListMenstrualCycle: path(ROOTS_ADMIN, "/dashboard/listMenstrualCycle"),
  admin_Login: path(ROOTS_ADMIN, "/adminLogin"),
};

// ------------------------------ BaseRole  Path----------------------------------------
export const PATH_BASE = {
  root: ROOTS_BASE,
  BasePanel: path(ROOTS_BASE, "/home"),
  WalletCallBack: path(ROOTS_BASE, "/walletCallBack"),
  BaseUserQuizzes: path(ROOTS_BASE, "/home/baseUserQuizzes"),
  BaseUserAccount: path(ROOTS_BASE, "/home/baseUserAccount"),
  BaseUserLoans: path(ROOTS_BASE, "/home/baseUserLoans"),
};
export const BREADCRUMB_TITLES_BASE = {
  BaseUserAccount: {
    path: path(ROOTS_BASE, "/home/baseUserAccount"),
    title: "پنل اصلی",
  },

  BaseUserLoans: {
    path: path(ROOTS_BASE, "/home/baseUserLoans"),
    title: "وام‌های کاربر",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },

  BaseUserQuizzes: {
    path: path(ROOTS_BASE, "/home/baseUserQuizzes"),
    title: "آزمون‌های کاربر",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
};

// ------------------------------ DoctorRole  Path----------------------------------------

export const PATH_DOCTOR = {
  root: ROOTS_DOCTOR,
  DoctorBase: path(ROOTS_DOCTOR, "/doctorBase"),
  Dashboard: path(ROOTS_DOCTOR, "/dashboard"),
  DoctorVisit: path(ROOTS_DOCTOR, "/dashboard/doctorVisit"),
  OfficePatients: path(ROOTS_DOCTOR, "/dashboard/officePatients"),
  ListIntroducesDoctor: path(ROOTS_DOCTOR, "/dashboard/listIntroducesDoctor"),
  DashboardContentDoctor: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
  ReportDoctor: path(ROOTS_DOCTOR, "/dashboard/reportDoctor"),
};
export const BREADCRUMB_TITLES_DOCTOR = {
  root: { path: ROOTS_DOCTOR, title: "پزشک" },

  doctorBase: {
    path: path(ROOTS_DOCTOR, "/doctorBase"),
    title: "پزشک",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },

  dashboard: {
    path: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
    title: "داشبورد",
    parent: path(ROOTS_DOCTOR, "/doctorBase"),
  },

  doctorVisit: {
    path: path(ROOTS_DOCTOR, "/dashboard/doctorVisit"),
    title: "پذیرش شدگان",
    parent: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
  },

  officePatients: {
    path: path(ROOTS_DOCTOR, "/dashboard/officePatients"),
    title: "بیماران",
    parent: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
  },

  listIntroducesDoctor: {
    path: path(ROOTS_DOCTOR, "/dashboard/listIntroducesDoctor"),
    title: "معرفی‌ها",
    parent: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
  },

  reportDoctor: {
    path: path(ROOTS_DOCTOR, "/dashboard/reportDoctor"),
    title: "گزارش‌ها",
    parent: path(ROOTS_DOCTOR, "/dashboard/DashboardContent"),
  },
};
// -------------------------------SecretaryRole   Path---------------------------------------
export const BREADCRUMB_TITLES_SECRETARY = {
  root: { path: ROOTS_SECRETARY, title: "منشی" },
  SecretaryBase: {
    path: path(ROOTS_SECRETARY, "/secretaryBase"),
    title: "پنل منشی",

    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  DashboardContent: {
    path: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_SECRETARY, "/secretaryBase"),
  },
  SecretaryPatients: {
    path: path(ROOTS_SECRETARY, "/dashboard/secretaryPatients"),
    title: "پذیرش",
    parent: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
  },
  SecretaryAppointments: {
    path: path(ROOTS_SECRETARY, "/dashboard/secretaryAppointments"),
    title: "ایجاد نوبت",
    parent: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
  },
  ListSecretaryAppointmentsAll: {
    path: path(ROOTS_SECRETARY, "/dashboard/listSecretaryAppointmentsAll"),
    title: "نوبت‌ دهی",
    parent: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
  },
  PatientMedicalInformation: {
    path: path(ROOTS_SECRETARY, "/dashboard/patientMedicalInformation"),
    title: "اطلاعات پزشکی بیمار",
    parent: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
  },
};
export const PATH_SECRETARY = {
  root: ROOTS_SECRETARY,
  SecretaryBase: path(ROOTS_SECRETARY, "/secretaryBase"),
  Dashboard: path(ROOTS_SECRETARY, "/dashboard"),
  SecretaryPatients: path(ROOTS_SECRETARY, "/dashboard/secretaryPatients"),
  SecretaryAppointments: path(
    ROOTS_SECRETARY,
    "/dashboard/secretaryAppointments"
  ),
  ListSecretaryAppointmentsAll: path(
    ROOTS_SECRETARY,
    "/dashboard/listSecretaryAppointmentsAll"
  ),

  DashboardContent: path(ROOTS_SECRETARY, "/dashboard/secretaryDashboard"),
  PatientMedicalInformation: path(
    ROOTS_SECRETARY,
    "/dashboard/patientMedicalInformation"
  ),
  SecretaryPatientBoard: path(ROOTS_SECRETARY, "/secretaryPatientBoard"),
};

// -------------------------------PatientsRole   Path---------------------------------------
export const BREADCRUMB_TITLES_PATIENT = {
  root: { path: ROOTS_PATIENT, title: "پیشخوان سلامت" },
  Patient: {
    path: path(ROOTS_PATIENT, "/dashboard/patient"),
    title: "پیشخوان سلامت",

    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  PatientAppointment: {
    path: path(ROOTS_PATIENT, "/dashboard/patientAppointment"),
    title: "نوبت دهی",
    parent: path(ROOTS_PATIENT, "/dashboard/patient"),
  },
};
export const PATH_PATIENT = {
  root: ROOTS_PATIENT,
  //SecretaryBase:path(ROOTS_PATIENT,"/secretaryBase"),
  Dashboard: path(ROOTS_PATIENT, "/dashboard"),
  PatientAppointment: path(ROOTS_PATIENT, "/dashboard/patientAppointment"),
  Patient: path(ROOTS_PATIENT, "/dashboard/patient"),
  AppointmentReservation: path(
    ROOTS_PATIENT,
    "/dashboard/appointmentReservation"
  ),
  Confirmation: path(ROOTS_PATIENT, "/confirmation"),
};

// -------------------------------SuuporterRole   Path---------------------------------------
export const BREADCRUMB_TITLES_SUPPORTER = {
  root: { path: ROOTS_SUPPORTER, title: "پشتیبان بیمار" },
  SupporterDashboard: {
    path: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
    title: "داشبورد",

    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  PatientSupporter: {
    path: path(ROOTS_SUPPORTER, "/dashboard/patientSupporter"),
    title: "عملیات پشتیبانی",
    parent: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
  },
  SupportContract: {
    path: path(ROOTS_SUPPORTER, "/dashboard/supportContract"),
    title: "قراداد ها",
    parent: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
  },
  SettlementRequest: {
    path: path(ROOTS_SUPPORTER, "/dashboard/settlementRequest"),
    title: "درخواست تسویه",
    parent: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
  },
  SupporterReport: {
    path: path(ROOTS_SUPPORTER, "/dashboard/supporterReport"),
    title: "گزارشات",
    parent: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
  },
};
export const PATH_SUPPORTER = {
  root: ROOTS_SUPPORTER,
  //SecretaryBase:path(ROOTS_PATIENT,"/secretaryBase"),
  Dashboard: path(ROOTS_SUPPORTER, "/dashboard"),
  PatientSupporter: path(ROOTS_SUPPORTER, "/dashboard/patientSupporter"),
  SupporterDashboard: path(ROOTS_SUPPORTER, "/dashboard/supporterDashboard"),
  SupporterReport: path(ROOTS_SUPPORTER, "/dashboard/supporterReport"),
  SettlementRequest: path(ROOTS_SUPPORTER, "/dashboard/settlementRequest"),
  SupportContract: path(ROOTS_SUPPORTER, "/dashboard/supportContract"),
};

// ------------------------------ ROOTS_ORGANIZATIONSYSTEM  Path----------------------------------------
export const BREADCRUMB_TITLES_ORGANIZATIONSYSTEM = {
  root: { path: ROOTS_ORGANIZATIONSYSTEM, title: "کارمند سازمان" },
  OrganizationSystemBase: {
    path: path(ROOTS_ORGANIZATIONSYSTEM, "/organizationSystemBase"),
    title: "پنل کارمند سازمان",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  OrganizationSystemDashboard: {
    path: path(
      ROOTS_ORGANIZATIONSYSTEM,
      "/dashboard/organizationSystemDashboard"
    ),
    title: "داشبورد",
    parent: path(ROOTS_ORGANIZATIONSYSTEM, "/organizationSystemBase"),
  },
  OrganizationSystemPatients: {
    path: path(
      ROOTS_ORGANIZATIONSYSTEM,
      "/dashboard/organizationSystemPatients"
    ),
    title: "ارجاع بیمار",
    parent: path(
      ROOTS_ORGANIZATIONSYSTEM,
      "/dashboard/organizationSystemDashboard"
    ),
  },
  OrganizationSystemReport: {
    path: path(ROOTS_ORGANIZATIONSYSTEM, "/dashboard/organizationSystemReport"),
    title: "گزارشات ارجاع",
    parent: path(
      ROOTS_ORGANIZATIONSYSTEM,
      "/dashboard/organizationSystemDashboard"
    ),
  },
  OrganizationSystemCharts: {
    path: path(ROOTS_ORGANIZATIONSYSTEM, "/dashboard/organizationSystemCharts"),
    title: "ساختار سازمان",
    parent: path(
      ROOTS_ORGANIZATIONSYSTEM,
      "/dashboard/organizationSystemDashboard"
    ),
  },
};
export const PATH_ORGANIZATIONSYSTEM = {
  root: ROOTS_ORGANIZATIONSYSTEM,
  OrganizationSystemBase: path(
    ROOTS_ORGANIZATIONSYSTEM,
    "/organizationSystemBase"
  ),
  Dashboard: path(ROOTS_ORGANIZATIONSYSTEM, "/dashboard"),
  OrganizationSystemDashboard: path(
    ROOTS_ORGANIZATIONSYSTEM,
    "/dashboard/organizationSystemDashboard"
  ),
  OrganizationSystemPatients: path(
    ROOTS_ORGANIZATIONSYSTEM,
    "/dashboard/organizationSystemPatients"
  ),
  OrganizationSystemReport: path(
    ROOTS_ORGANIZATIONSYSTEM,
    "/dashboard/organizationSystemReport"
  ),
  OrganizationSystemCharts: path(
    ROOTS_ORGANIZATIONSYSTEM,
    "/dashboard/organizationSystemCharts"
  ),
};
// ------------------------------ Organization  Path----------------------------------------
export const BREADCRUMB_TITLES_ORGANIZATION = {
  root: { path: ROOTS_ORGANIZATION, title: "مدیر سازمان" },
  OrganizationBase: {
    path: path(ROOTS_ORGANIZATION, "/organizationBase"),
    title: "پنل سازمان",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  OrganizationDashboard: {
    path: path(ROOTS_ORGANIZATION, "/dashboard/organizationDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_ORGANIZATION, "/organizationBase"),
  },
  OrganizationPatients: {
    path: path(ROOTS_ORGANIZATION, "/dashboard/organizationPatients"),
    title: "ارجاع بیمار",
    parent: path(ROOTS_ORGANIZATION, "/dashboard/organizationDashboard"),
  },
  OrganizationReport: {
    path: path(ROOTS_ORGANIZATION, "/dashboard/organizationReport"),
    title: "گزارشات ارجاع",
    parent: path(ROOTS_ORGANIZATION, "/dashboard/organizationDashboard"),
  },
};
export const PATH_ORGANIZATION = {
  root: ROOTS_ORGANIZATION,
  OrganizationBase: path(ROOTS_ORGANIZATION, "/organizationBase"),
  Dashboard: path(ROOTS_ORGANIZATION, "/dashboard"),
  OrganizationDashboard: path(
    ROOTS_ORGANIZATION,
    "/dashboard/organizationDashboard"
  ),
  OrganizationPatients: path(
    ROOTS_ORGANIZATION,
    "/dashboard/organizationPatients"
  ),
  OrganizationReport: path(ROOTS_ORGANIZATION, "/dashboard/organizationReport"),
  OrganizationCharts: path(ROOTS_ORGANIZATION, "/dashboard/OrganizationCharts"),
};

// ------------------------------ HealthCenter  Path----------------------------------------

export const PATH_HEALTHCENTER = {
  root: ROOTS_HEALTHCENTER,
  HealthCenterBase: path(ROOTS_HEALTHCENTER, "/healthCenterBase"),
  Dashboard: path(ROOTS_HEALTHCENTER, "/dashboard"),
  HealthCenterDashboard: path(
    ROOTS_HEALTHCENTER,
    "/dashboard/healthCenterDashboard"
  ),
  HealthCenterReceptions: path(
    ROOTS_HEALTHCENTER,
    "/dashboard/healthCenterReceptions"
  ),
};

// -------------------------------RadiologyRole   Path---------------------------------------
export const BREADCRUMB_TITLES_RADIOGRAPHY = {
  root: { path: ROOTS_RADIOGRAPHY, title: "مدیر تصویربرداری" },
  RadiographyBase: {
    path: path(ROOTS_RADIOGRAPHY, "/radiographyBase"),
    title: "پنل تصویربرداری",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  RadiographyDashboardContent: {
    path: path(ROOTS_RADIOGRAPHY, "/dashboard/radiographyDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_RADIOGRAPHY, "/radiographyBase"),
  },
  RadiographyReception: {
    path: path(ROOTS_RADIOGRAPHY, "/dashboard/radiographyReception"),
    title: "پذیرش",
    parent: path(ROOTS_RADIOGRAPHY, "/dashboard/radiographyDashboard"),
  },
  RadiographyAppointment: {
    path: path(ROOTS_RADIOGRAPHY, "/dashboard/radiographyAppointment"),
    title: "ایجاد نوبت",
    parent: path(ROOTS_RADIOGRAPHY, "/dashboard/radiographyDashboard"),
  },
};
export const PATH_RADIOGRAPHY = {
  root: ROOTS_RADIOGRAPHY,
  RadiographyBase: path(ROOTS_RADIOGRAPHY, "/radiographyBase"),
  Dashboard: path(ROOTS_RADIOGRAPHY, "/dashboard"),
  RadiographyDashboardContent: path(
    ROOTS_RADIOGRAPHY,
    "/dashboard/radiographyDashboard"
  ),
  RadiographyReception: path(
    ROOTS_RADIOGRAPHY,
    "/dashboard/radiographyReception"
  ),
  RadiographyAppointment: path(
    ROOTS_RADIOGRAPHY,
    "/dashboard/radiographyAppointment"
  ),
};
// -------------------------------RadiologySystemRole   Path---------------------------------------
export const BREADCRUMB_TITLES_RADIOGRAPHYSYSTEM = {
  root: { path: ROOTS_RADIOGRAPHY_SYSTEM, title: "کارمند تصویربرداری" },
  RadiographySystemBase: {
    path: path(ROOTS_RADIOGRAPHY_SYSTEM, "/radiographySystemBase"),
    title: "پنل کارمند تصویربرداری",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  RadiographySystemDashboardContent: {
    path: path(
      ROOTS_RADIOGRAPHY_SYSTEM,
      "/dashboard/radiographySystemDashboard"
    ),
    title: "داشبورد",
    parent: path(ROOTS_RADIOGRAPHY_SYSTEM, "/radiographySystemBase"),
  },
  RadiographySystemReception: {
    path: path(
      ROOTS_RADIOGRAPHY_SYSTEM,
      "/dashboard/radiographySystemReception"
    ),
    title: "پذیرش",
    parent: path(
      ROOTS_RADIOGRAPHY_SYSTEM,
      "/dashboard/radiographySystemDashboard"
    ),
  },
  RadiographySystemAppointment: {
    path: path(
      ROOTS_RADIOGRAPHY_SYSTEM,
      "/dashboard/radiographySystemAppointment"
    ),
    title: "ایجاد نوبت",
    parent: path(
      ROOTS_RADIOGRAPHY_SYSTEM,
      "/dashboard/radiographySystemDashboard"
    ),
  },
};
export const PATH_RADIOGRAPHY_SYSTEM = {
  root: ROOTS_RADIOGRAPHY_SYSTEM,
  RadiographySystemBase: path(
    ROOTS_RADIOGRAPHY_SYSTEM,
    "/radiographySystemBase"
  ),
  Dashboard: path(ROOTS_RADIOGRAPHY_SYSTEM, "/dashboard"),
  RadiographySystemDashboardContent: path(
    ROOTS_RADIOGRAPHY_SYSTEM,
    "/dashboard/radiographySystemDashboard"
  ),
  RadiographySystemReception: path(
    ROOTS_RADIOGRAPHY_SYSTEM,
    "/dashboard/radiographySystemReception"
  ),
  RadiographySystemAppointment: path(
    ROOTS_RADIOGRAPHY_SYSTEM,
    "/dashboard/radiographySystemAppointment"
  ),
};
// -------------------------------LablatoryRole   Path---------------------------------------
export const BREADCRUMB_TITLES_LABORATORY = {
  root: { path: ROOTS_LABORATORY, title: "مدیر آزمایشگاه" },
  LaboratoryBase: {
    path: path(ROOTS_LABORATORY, "/laboratoryBase"),
    title: "پنل آزمایشگاه",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  LaboratoryDashboardContent: {
    path: path(ROOTS_LABORATORY, "/dashboard/laboratoryDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_LABORATORY, "/laboratoryBase"),
  },
  LaboratoryReception: {
    path: path(ROOTS_LABORATORY, "/dashboard/laboratoryReception"),
    title: "پذیرش",
    parent: path(ROOTS_LABORATORY, "/dashboard/laboratoryDashboard"),
  },
  LaboratoryAppointment: {
    path: path(ROOTS_LABORATORY, "/dashboard/laboratoryAppointment"),
    title: "ایجاد نوبت",
    parent: path(ROOTS_LABORATORY, "/dashboard/laboratoryDashboard"),
  },
};
export const PATH_LABORATORY = {
  root: ROOTS_LABORATORY,
  LaboratoryBase: path(ROOTS_LABORATORY, "/laboratoryBase"),
  LaboratoryDashboardContent: path(
    ROOTS_LABORATORY,
    "/dashboard/laboratoryDashboard"
  ),
  Dashboard: path(ROOTS_LABORATORY, "/dashboard"),
  LaboratoryReception: path(ROOTS_LABORATORY, "/dashboard/laboratoryReception"),
  LaboratoryAppointment: path(
    ROOTS_LABORATORY,
    "/dashboard/laboratoryAppointment"
  ),
};
// -------------------------------LablatorySystemRole   Path---------------------------------------
export const BREADCRUMB_TITLES_LABORATORYSYSTEM = {
  root: { path: ROOTS_RADIOGRAPHY_SYSTEM, title: "کارمند آزمایشگاه" },
  LaboratorySystemBase: {
    path: path(ROOTS_LABORATORY_SYSTEM, "/laboratorySystemBase"),
    title: "پنل کارمند آزمایشگاه",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  LaboratorySystemDashboardContent: {
    path: path(ROOTS_LABORATORY_SYSTEM, "/dashboard/laboratorySystemDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_LABORATORY_SYSTEM, "/laboratorySystemBase"),
  },
  LaboratorySystemReception: {
    path: path(ROOTS_LABORATORY_SYSTEM, "/dashboard/laboratorySystemReception"),
    title: "پذیرش",
    parent: path(
      ROOTS_LABORATORY_SYSTEM,
      "/dashboard/laboratorySystemDashboard"
    ),
  },
  laboratorySystemAppointment: {
    path: path(
      ROOTS_LABORATORY_SYSTEM,
      "/dashboard/laboratorySystemAppointment"
    ),
    title: "ایجاد نوبت",
    parent: path(
      ROOTS_LABORATORY_SYSTEM,
      "/dashboard/laboratorySystemDashboard"
    ),
  },
};
export const PATH_LABORATORY_SYSTEM = {
  root: ROOTS_LABORATORY_SYSTEM,
  LaboratorySystemBase: path(ROOTS_LABORATORY_SYSTEM, "/laboratorySystemBase"),
  Dashboard: path(ROOTS_LABORATORY_SYSTEM, "/dashboard"),
  LaboratorySystemDashboardContent: path(
    ROOTS_LABORATORY_SYSTEM,
    "/dashboard/laboratorySystemDashboard"
  ),
  LaboratorySystemReception: path(
    ROOTS_LABORATORY_SYSTEM,
    "/dashboard/laboratorySystemReception"
  ),
  LaboratorySystemAppointment: path(
    ROOTS_LABORATORY_SYSTEM,
    "/dashboard/laboratorySystemAppointment"
  ),
};
// -------------------------------DrugstoreRole  Path---------------------------------------
export const BREADCRUMB_TITLES_DRUGSTORE = {
  root: { path: ROOTS_DRUGSTORE, title: "مدیر داروخانه" },
  DrugstoreBase: {
    path: path(ROOTS_DRUGSTORE, "/drugstoreBase"),
    title: "پنل داروخانه",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  DrugstoreDashboardContent: {
    path: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_DRUGSTORE, "/drugstoreBase"),
  },
  DrugstoreReception: {
    path: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreReception"),
    title: "پذیرش",
    parent: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreDashboard"),
  },
  DrugstoreAppointment: {
    path: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreAppointment"),
    title: "ایجاد نوبت",
    parent: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreDashboard"),
  },
};
export const PATH_DRUGSTORE = {
  root: ROOTS_DRUGSTORE,
  DrugstoreBase: path(ROOTS_DRUGSTORE, "/drugstoreBase"),
  Dashboard: path(ROOTS_DRUGSTORE, "/dashboard"),
  DrugstoreDashboardContent: path(
    ROOTS_DRUGSTORE,
    "/dashboard/drugstoreDashboard"
  ),
  DrugstoreReception: path(ROOTS_DRUGSTORE, "/dashboard/drugstoreReception"),
  DrugstoreAppointment: path(
    ROOTS_DRUGSTORE,
    "/dashboard/drugstoreAppointment"
  ),
};
// -------------------------------DrugstoreSystemRole  Path---------------------------------------
export const BREADCRUMB_TITLES_DRUGSTORESYSTEM = {
  root: { path: ROOTS_DRUGSTORE_SYSTEM, title: "کارمند داروخانه" },
  DrugstoreSystemBase: {
    path: path(ROOTS_DRUGSTORE_SYSTEM, "/drugstoreSystemBase"),
    title: "پنل کارمند داروخانه",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  DrugstoreSystemDashboardContent: {
    path: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard/drugstoreSystemDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_DRUGSTORE_SYSTEM, "/drugstoreSystemBase"),
  },
  DrugstoreSystemReception: {
    path: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard/drugstoreSystemReception"),
    title: "پذیرش",
    parent: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard/drugstoreSystemDashboard"),
  },
  DrugstoreSystemAppointment: {
    path: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard/drugstoreSystemAppointment"),
    title: "ایجاد نوبت",
    parent: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard/drugstoreSystemDashboard"),
  },
};
export const PATH_DRUGSTORE_SYSTEM = {
  root: ROOTS_DRUGSTORE_SYSTEM,
  DrugstoreSystemBase: path(ROOTS_DRUGSTORE_SYSTEM, "/drugstoreSystemBase"),
  Dashboard: path(ROOTS_DRUGSTORE_SYSTEM, "/dashboard"),
  DrugstoreSystemDashboardContent: path(
    ROOTS_DRUGSTORE_SYSTEM,
    "/dashboard/drugstoreSystemDashboard"
  ),
  DrugstoreSystemReception: path(
    ROOTS_DRUGSTORE_SYSTEM,
    "/dashboard/drugstoreSystemReception"
  ),
  DrugstoreSystemAppointment: path(
    ROOTS_DRUGSTORE_SYSTEM,
    "/dashboard/drugstoreSystemAppointment"
  ),
};
// -------------------------------LenderRole  Path---------------------------------------
export const BREADCRUMB_TITLES_LENDER = {
  root: { path: ROOTS_LENDER, title: "مدیر موسسه / وام دهنده" },
  LenderBase: {
    path: path(ROOTS_LENDER, "/lenderBase"),
    title: "پنل موسسه / وام دهنده",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  LenderDashboardContent: {
    path: path(ROOTS_LENDER, "/dashboard/lenderDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_LENDER, "/lenderBase"),
  },
  LenderLoan: {
    path: path(ROOTS_LENDER, "/dashboard/lenderLoan"),
    title: "لیست وام ها",
    parent: path(ROOTS_LENDER, "/dashboard/lenderDashboard"),
  },
  LenderLoanRequest: {
    path: path(ROOTS_LENDER, "/dashboard/loanRequest"),
    title: "لیست درخواست ها",
    parent: path(ROOTS_LENDER, "/dashboard/lenderDashboard"),
  },
};
export const PATH_LENDER = {
  root: ROOTS_LENDER,
  LenderBase: path(ROOTS_LENDER, "/lenderBase"),
  Dashboard: path(ROOTS_LENDER, "/dashboard"),
  LenderDashboardContent: path(ROOTS_LENDER, "/dashboard/lenderDashboard"),
  LenderLoan: path(ROOTS_LENDER, "/dashboard/lenderLoan"),
  LenderLoanRequest: path(ROOTS_LENDER, "/dashboard/loanRequest"),
  // DrugstoreTamin: path(ROOTS_LENDER, "/dashboard/drugstoreTamin"),
};

// -------------------------------LenderSystemRole  Path---------------------------------------
export const BREADCRUMB_TITLES_LENDERSYSTEM = {
  root: { path: ROOTS_LENDER_SYSTEM, title: "کارمند موسسه / وام دهنده" },
  LenderSystemBase: {
    path: path(ROOTS_LENDER_SYSTEM, "/lenderSystemBase"),
    title: "پنل کارمند موسسه / وام دهنده",
    parent: path(ROOTS_BASE, "/home/baseUserAccount"),
  },
  LenderSystemDashboardContent: {
    path: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemDashboard"),
    title: "داشبورد",
    parent: path(ROOTS_LENDER_SYSTEM, "/lenderSystemBase"),
  },
  LenderSystemLoan: {
    path: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemLoan"),
    title: "لیست وام ها",
    parent: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemDashboard"),
  },
  LenderSystemLoanRequest: {
    path: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemLoanRequest"),
    title: "لیست درخواست ها",
    parent: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemDashboard"),
  },
};
export const PATH_LENDER_SYSTEM = {
  root: ROOTS_LENDER_SYSTEM,
  LenderSystemBase: path(ROOTS_LENDER_SYSTEM, "/lenderSystemBase"),
  Dashboard: path(ROOTS_LENDER_SYSTEM, "/dashboard"),
  LenderSystemDashboardContent: path(
    ROOTS_LENDER_SYSTEM,
    "/dashboard/lenderSystemDashboard"
  ),
  LenderSystemLoan: path(ROOTS_LENDER_SYSTEM, "/dashboard/lenderSystemLoan"),
  LenderSystemLoanRequest: path(
    ROOTS_LENDER_SYSTEM,
    "/dashboard/lenderSystemLoanRequest"
  ),
  // DrugstoreTamin: path(ROOTS_LENDER, "/dashboard/drugstoreTamin"),
};
